module.exports = __webpack_public_path__ + "static/bookey-1c42d00e0f3c7b9089335d44418e8ce1.png";